/**
 * Module dependencies
 */
import { Container, Row, Col } from 'react-bootstrap';
import download from './download.svg';

/**
 * Styles
 */
import './index.scss';

/**
 * Hero component
 */
function Hero(props: any) {
  return (
    <section className={`Hero Hero__${props.isLaunch ? 'launch' : 'prelaunch'}`}>
      <Container>
        <Row>
          <Col md={8}>
            <h1 className='Hero__title'>10x Stocks is your <br /> AI Stock Copilot</h1>
            <div className='Hero__wrapper-subscribe'>
              <p className={`Hero__subtitle ${props.isLaunch ? '' : 'd-none d-md-block'}`}>
                Get instant Buy-Sell-Hold recommendations <br />of any stock  in seconds powered by AI <br />(ChatGPT, Grok, Gemini)
              </p>
              <a href={`${process.env.REACT_APP_APPLE_STORE_URL}`} target='_blank'>
                <img
                  src={download}
                  className="PreFooter__free-trial-download-img"
                  alt="Download on the App Store"
                />
              </a>
            </div>
            {/* Images */}
            <div className='Hero__stocks-absolute-img'></div>
            <div className='Hero__stocks-relative-img'></div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

/**
 * Expose component
 */
export default Hero;
